import { createBrowserHistory } from 'history';
const history = createBrowserHistory({ basename: '/crypto-chimpz' });
export default history;
